import useStepWithNext from 'components/StepLine/context/hooks/useStepWithNext'
import StepLineModal from 'components/StepLine/StepLineModal'
import React from 'react'
import { ThemedText } from 'theme'

import { useRewards } from '../../context/RewardContext'
import KodiakFarmClaimStep from '../steps/KodiakFarmClaimStep'

const FarmClaimModal: React.FC = () => {
  const { activeModal, closeModal, kodiakFarmEarned, claimTxState, claimKodiakFarmRewards } = useRewards()

  // Create claim step
  const kodiakFarmClaimStep = useStepWithNext('kodiakFarmClaim', KodiakFarmClaimStep, {
    earnedAmount: kodiakFarmEarned,
    attemptingTxn: claimTxState.attemptingTx,
    hash: claimTxState.hash,
    autoConfirm: true,
    transactionWaiting: claimTxState.transactionWaiting,
    onStart: claimKodiakFarmRewards,
    pendingText: 'Claiming rewards...',
    error: claimTxState.error,
  })

  // Modal header
  const modalHeader = <ThemedText.DeprecatedMediumHeader>Claim Farm Rewards</ThemedText.DeprecatedMediumHeader>

  return (
    <StepLineModal
      isOpen={activeModal === 'farmClaim'}
      onDismiss={closeModal}
      steps={[kodiakFarmClaimStep]}
      header={modalHeader}
      onFinish={closeModal}
    />
  )
}

export default FarmClaimModal
